<template>
  <ActionModal
    v-model="modalDelete"
    title="Удалить квиз?"
    :actions="buttonsDeleteModal"
  />
  <LoaderComponent v-if="getStatusLoadingQuizList == 'loading'" />
  <div :class="style.quizListBlock" v-else>
    <SectionHeaderBlock
      title="Ваши квизы"
      subTitle="В вашем аккаунте пока нет созданных квизов."
      :conditionSubTitle="!quizList.length"
      :class="style.headerBlock"
    >
      <template #buttons>
        <PrimaryButton
          text="Создать"
          :disabled="isCreatingQuiz"
          @click="createNewQuiz"
        />
      </template>
    </SectionHeaderBlock>
    <QuizItem
      v-for="(quiz, index) in quizList"
      :key="quiz._id"
      :index="index"
      @updateIdDelete="setIdDelete"
    >
      {{ quiz.name }}
    </QuizItem>
  </div>
</template>
<script lang="ts">
import {API} from "@/api/generated";
import style from "./QuizList.module.scss";
import {defineComponent} from "vue";
import QuizItem from "@/page/quiz/editor/List/components/QuizItem.vue";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import {loudingQuizList, QuizListItem} from "../../typeQuiz";
import {createQuiz} from "./services";
import ActionModal from "@/layout/nav/components/modal/modals/ActionModal/ActionModal.vue";
import SectionHeaderBlock from "@/elements/UI/section/SectionHeaderBlock/SectionHeaderBlock.vue";
import LoaderComponent from "@/elements/UI/overlay/Loader/LoaderComponent.vue";

export default defineComponent({
  components: {
    LoaderComponent,
    SectionHeaderBlock,
    ActionModal,
    PrimaryButton,
    QuizItem
  },
  data() {
    return {
      style,
      idDelete: "",
      modalDelete: false,
      isCreatingQuiz: false,
      isDeletingQuiz: false
    };
  },
  mounted() {
    void this.setData();
    this.$quizStore.setSelectedQuestion(-1);
  },
  methods: {
    setIdDelete(id: string): void {
      this.idDelete = id;
      this.modalDelete = true;
    },

    async setData(): Promise<void> {
      this.$quizStore.fetchQuizList();
    },

    async createNewQuiz(): Promise<void> {
      if (this.isCreatingQuiz) {
        return;
      }

      this.isCreatingQuiz = true;

      try {
        await createQuiz();
      } catch (error) {
        console.error("Ошибка при создании квиза:", error);
      } finally {
        this.isCreatingQuiz = false;
      }
    },

    async deleteQuiz(): Promise<void> {
      if (!this.idDelete || this.isDeletingQuiz) {
        return;
      }

      this.isDeletingQuiz = true;

      try {
        await API.deleteQuiz({body: {id: this.idDelete}});
        this.$quizStore.deleteQuiz(this.idDelete);
        this.idDelete = "";
        this.modalDelete = false;
      } catch (error) {
        console.error("Ошибка при удалении квиза:", error);
      } finally {
        this.isDeletingQuiz = false;
      }
    }
  },
  computed: {
    getStatusLoadingQuizList(): loudingQuizList {
      return this.$quizStore.getStatusLoadingQuizList;
    },
    quizList(): QuizListItem[] {
      return this.$quizStore.getQuizList;
    },
    buttonsDeleteModal(): ListActionItem[] {
      return [
        {
          text: "Удалить",
          handler: this.deleteQuiz,
          disabled: this.isDeletingQuiz
        },
        {
          text: "Отмена",
          handler: () => (this.modalDelete = false),
          disabled: this.isDeletingQuiz
        }
      ];
    }
  },
  watch: {
    idDelete() {
      this.modalDelete = this.idDelete != "";
    },
    modalDelete(data) {
      if (data == false) {
        this.idDelete = "";
      }
    }
  }
});
</script>
